export default function getSellerSlug(seller) {
  return seller.name ? seller.name : seller._id;
}
